<style scoped>
  .button-selection{background-color: #2d8cf0;color: #fff}
  /*选择器样式*/
  .button-class{width: 108px;height: 38px;border: 1px solid #d7dde4;border-radius: 19px;text-align: center;margin-top: -19px;margin-right: 40px;}
  .search >>> .ivu-input{width: 440px;height: 40px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .notice-background{background: url("/img/sys/bg8.png");height: 140px;}
  .search{width: 800px;height: 530px;border: 1px solid #d7dde4;text-align: center;display: inline-block;margin-top:70px;margin-bottom:70px;}
</style>

<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <div style="background-color: #fff;text-align: center;">
      <div class="search">
        <div>
          <Button v-for="(item,index) in typeList" @click="search.type = item.id" class="button-class" :class="item.id == search.type  ? 'button-selection' : '' ">{{item.name}}</Button>
        </div>
        <div style="margin-top: 40px;">
          <div style="position: relative;width: 440px;left: 50%;transform: translateX(-50%);">
            <Input @keyup.enter.native="$router.push({name:'archivesList',query:{type:search.type,text:search.text}})" class="search-input" v-model="search.text" placeholder="项目名称、主体名称、主办人"></Input>
            <div @click="$router.push({name:'archivesList',query:{type:search.type,text:search.text}})" style="background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 6px;text-align: center;right: 10px;cursor:pointer;">
              <img style="margin-top: 6px;" src="/img/project/search-icon.png"/>
            </div>
          </div>
          <div style="margin-top:50px;">
            <img src="/img/search/archives.png">
            <p style="color: #657180;font-size: 36px;">智能私有云档案</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "search",
    data() {
      return {
        typeList:[],
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          type:'',//案件类型
          text:'',//搜索文字
        },
      }
    },
    mounted:function(){
      this.getTypeList()
    },
    methods: {
      getTypeList : function () {
        var _this = this
        _this.typeList = []
        _this.send({
          headers: "C/CaseTypeList",
          success : function (res) {
            for(var index in res.TypeList){
              var tempObj =  {
                id:res.TypeList[index].CaseTypeId,
                name:res.TypeList[index].CaseTypeTitle,
              }
              _this.typeList.push(tempObj)
              _this.search.type = _this.typeList[0].id
            }
          }
        })
      },
      searchArchives:function(){
        var _this = this
        _this.send({
          headers:'RC/RecordList',
          data:{
            SearchWord:_this.search.text,
            CaseTypeId:_this.search.type,
          },
          success:function (res) {

          }
        })
      },
    },

  }
</script>
